export var AvatarVariants;
(function (AvatarVariants) {
    AvatarVariants["brand"] = "brand";
    AvatarVariants["user"] = "user";
    AvatarVariants["card"] = "card";
})(AvatarVariants || (AvatarVariants = {}));
//# sourceMappingURL=constants.js.map